import { Share } from 'lucide-react';
import {
  MenuItem,
  useMessageMenuContext,
} from '@sendbird/uikit-react/ui/MessageMenu';
import { useTranslate } from 'ra-core';
import {
  type SendableMessage,
  useForwardMessageContext,
} from '../../ForwardMessageProvider';
import { MenuItemBoxContainer } from './MessageCustomMenu';

type ForwardMenuItemProps = {
  message: SendableMessage;
};

export const ForwardMenuItem: React.FC<ForwardMenuItemProps> = ({
  message,
}) => {
  const translate = useTranslate();
  const menuContext = useMessageMenuContext();
  const forwardMessageContext = useForwardMessageContext();

  const handleOnClick = () => {
    forwardMessageContext.setMessage(message);
    forwardMessageContext.setShowModal(true);
    menuContext.hideMenu();
  };

  return (
    <>
      <MenuItem onClick={handleOnClick}>
        <MenuItemBoxContainer>
          <Share />
          <span>{translate('chat.forward')}</span>
        </MenuItemBoxContainer>
      </MenuItem>
    </>
  );
};
